// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file employee.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file employee.proto.
 */
export const file_employee: GenFile = /*@__PURE__*/
  fileDesc("Cg5lbXBsb3llZS5wcm90bxILZ3JwYy5hcGkudjEiMwoIRW1wbG95ZWUSCgoCaWQYASABKAMSDAoEbmFtZRgDIAEoCRINCgVvcmRlchgCIAEoA0IGWgQuO3BiYgZwcm90bzM");

/**
 * Employee
 *
 * @generated from message grpc.api.v1.Employee
 */
export type Employee = Message<"grpc.api.v1.Employee"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: int64 order = 2;
   */
  order: bigint;
};

/**
 * Describes the message grpc.api.v1.Employee.
 * Use `create(EmployeeSchema)` to create a new message.
 */
export const EmployeeSchema: GenMessage<Employee> = /*@__PURE__*/
  messageDesc(file_employee, 0);

